import { css } from '@emotion/css';
import { Popup } from 'Shared/forms/Popup';


const colourPatchStyle = () => css({
	margin: '0 0.2em 0.5em',
	border: 'solid 1px black',
	borderRadius: '2em',
	height: '2em',
});


export function ColourPickerPopup(P)
{
	return (
		<Popup title="Colour" moveable close={P.close}>
			<div class={colourPatchStyle()} style={{'background-color': P.value}} />
			{P.children}
		</Popup>
	);
}
